import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import createSmartInput from '@arivaa-react/components/createSmartInput';
import { forwardRef, useEffect } from 'react';
import { useSecureApi } from '../../hooks/api';
import { url } from '../../constants/api';
export const ApiAutoCompleteSelect = createSmartInput(
  forwardRef(
    ({ value, onChange, api, params, selectProps, formatter }, ref) => {
      const { callApi, data, loading } = useSecureApi();
      const placeholder = api
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

      const { search, ...restParams } = params;
      useEffect(() => {
        callApi(url(`${api}`), {
          params: restParams,
        });
      }, []);
      return (
        <Select
          ref={ref}
          style={{ width: '100%' }}
          loading={loading}
          filterOption={false}
          notFoundContent={loading ? <Spin size="small" /> : null}
          showSearch={true}
          onSearch={debounce(
            (text) =>
              text?.trim() !== ''
                ? callApi(url(`${api}`), {
                    params: {
                      search: search(text),
                      ...restParams,
                    },
                  })
                : null,
            800
          )}
          placeholder={`Select ${placeholder}`}
          {...selectProps}
          options={(data || []).map(
            formatter
              ? formatter
              : ({ key, name }) => ({
                  label: name ? name : key,
                  value: key,
                })
          )}
          value={value}
          onSelect={onChange}
        />
      );
    }
  )
);
